module.exports = __webpack_public_path__ + "img/NDZ_Insta.cdad3bfc.svg";